import { Person } from "./Person";
import HasSearchHelp from "./HasSearchHelp";
import { Speciality } from "./Speciality";
import { PrescriberProgramAccountManager } from "./PrescriberProgramAccountManager";
import TextUtils from "@/util/TextUtils";

export interface Prescriber extends Person {
    emailAddress: string;
    practiceName: string;
    phoneNumber: string;
    altNumber: string;
    faxNumber: string;
    altFaxNumber: string;

    deaNumber: string;
    npiNumber: string;

    stateLicenseNumber: string;
    sureScriptsId: string;
    programId: number | null;

    allowsPa: boolean;
    reminderOptOut: boolean;
    alert: string;
    contacts: PrescriberContact[];

    hoursOfOperation?: string;
    medicaidNumber?: string;
    communicationPreference?: PrescriberCommunicationPreference;

    specialities: Speciality[];

    accountManagerUserId?: string;
    accountManagerFirstName?: string;
    accountManagerLastName?: string;
    programAccountManagers?: PrescriberProgramAccountManager[];

    requiresSupervisingPhysician?: boolean;
}

export class Prescriber extends Person implements HasSearchHelp {
    constructor(prescriber?: Prescriber) {
        super();
        this.allowsPa = true;
        this.specialities = [];
        if (prescriber) Object.assign(this, prescriber);
    }

    toString(): string {
        if(this.id && this.lastName) {
            return "ID: " + this.id + " " + TextUtils.escapeHtml(this.lastName)
                + (this.firstName ? ", " + TextUtils.escapeHtml(this.firstName) : "")
                + (this.fullAddress ? ", " + TextUtils.escapeHtml(this.fullAddress) : "");
        }
        if (this.lastName && this.firstName) {
            return TextUtils.escapeHtml(this.lastName)
                + ", " + TextUtils.escapeHtml(this.firstName)
                + (this.fullAddress ? ", " + TextUtils.escapeHtml(this.fullAddress) : "");
        }
        return '<div class="font-weight-light">NPI/DEA/Name/PhoneNumber/FaxNumber</div>';
    }

    getSearchHelpHtml() : string {
        return "<p>Search for prescribers using any of the following formats:</p>" +
        "<ul>" +
        "<li>Prescriber Name: \"LastName, FirstName\"</li>" +
        "<li>NPI: \"123456789\"</li>" +
        "<li>DEA Number: \"AB1234567\"</li>" +
        "<li>Phone Number: \"+1XXX...\"</li>" +
        "<li>Fax Number: \"+1XXX...\"</li>" +
        "</ul>";
    }

}

export interface PrescriberContact {
    id: number;
    lastName: string;
    firstName: string;
    title: string;
    phoneNumber: string;
    note: string;
}

export class PrescriberContact {

}

export enum PrescriberCommunicationPreference
{
    email,
    fax,
    call,
    portal
}
